import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { store } from 'store';
import App from 'tsx/features/main/App';

import { setupAxiosInterceptors } from '~libs/axiosInterceptors';

// setup axios interceptors here to avoid circular dependency (store import in reducer)
setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Provider store={store}>
      <App />
    </Provider>
  </LocalizationProvider>,
);
